import axios from "axios";
import cookieStorage from "./cookieStorage";

const AUTH_COOKIE_KEYS = [
    "userId",
    "accessToken",
    "isAdmin",
    "priceClass",
    "priceid",
    "rewardsThreshold",
    "countdownTime",
    "customerId",
    "isTileView",
    "firstLogin",
    "childCustomers",
    "rewards"
];

function clearAuthStorage() {
    AUTH_COOKIE_KEYS.forEach((key) => cookieStorage.removeItem(key));
}

function isAuthRoute(url) {
    if (!url) return false;
    return (
        url.includes("/auth/login") ||
        url.includes("/auth/register") ||
        url.includes("/auth/forgot") ||
        url.includes("/auth/request") ||
        url.includes("/auth/reset-password")
    );
}

export default function setupAxiosInterceptors() {
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error?.response?.status;
            const requestUrl = error?.config?.url;

            if (status === 401 && !isAuthRoute(requestUrl)) {
                console.warn(
                    "[Auth] Session expired — received 401. Redirecting to login."
                );
                clearAuthStorage();

                if (window.location.pathname !== "/login") {
                    window.location.href = "/login";
                }
            }

            return Promise.reject(error);
        }
    );
}
